<template>
  <div>
    <md-table>
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Website Content</h1>
        </div>
      </md-table-toolbar>
      <md-table-row>
        <md-table-head>Meta title</md-table-head>
        <md-table-cell>{{ content.metaTitle }}</md-table-cell>
      </md-table-row>
      <md-table-row>
        <md-table-head>Meta Description</md-table-head>
        <md-table-cell>{{ content.metaDescription }}</md-table-cell>
      </md-table-row>
      <md-table-row>
        <md-table-head>Title</md-table-head>
        <md-table-cell>{{ content.title }}</md-table-cell>
      </md-table-row>
      <md-table-row>
        <md-table-head>Logo</md-table-head>
        <md-table-cell>
          <img width="200" :src="content.logo" alt />
        </md-table-cell>
      </md-table-row>
      <md-table-row>
        <md-table-head>Heading</md-table-head>
        <md-table-cell>{{ content.heading }}</md-table-cell>
      </md-table-row>
      <md-table-row>
        <md-table-head>Sub Heading</md-table-head>
        <md-table-cell>{{ content.subHeading }}</md-table-cell>
      </md-table-row>
      <md-table-row>
        <md-table-head></md-table-head>
        <md-table-cell v-if="content._id">
          <router-link
            :to="{ name: 'EditContent', params: { id: content._id} }"
            class="btn btn-primary text-white"
          >Edit</router-link>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  name: "newFooterMenu",
  data() {
    return {
      content: {}
    };
  },
  created() {
    Axios.get(`${process.env.VUE_APP_API_URL}/api/content`)
      .then(res => {
        this.content = res.data;
        // console.log(res.data);
      })
      .catch(err => console.log(err));
  }
};
</script>
